import React, { useState, useEffect } from 'react';
import InventoryManagement from '../InventoryManagement';
import DeviceInformation from '../DeviceInformation';

function Inventory({ refreshList, notification, handleClose, selectedDevice, action }) {
  const [selectedTab, selectTab] = useState(action === 'update' ? 3 : 1);
  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20 "
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),  rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-3/5 pb-8 px-10 relative rounded-3xl">
        <img
          src="assets/img/Close.svg"
          className="absolute top-5 right-10 h-4 cursor-pointer"
          alt=""
          onClick={handleClose}
        />
        {/* <div className="flex">
     <button
      className={`font-bold text-xl cursor-pointer pb-2 focus:outline-none ${
       selectedTab === 1 ? 'text-textBlue1 border-b-4 border-blueBtn' : 'text-parameter opacity-60'
      }`}
      
     >
      Inventory Management
     </button>
     <button
      className={`font-bold text-xl cursor-pointer ml-14 pb-2 focus:outline-none ${
       selectedTab === 2 ? 'text-textBlue1 border-b-4 border-blueBtn' : 'text-parameter opacity-60'
      }`}
     >
      Device Information
     </button>
     <button
      className={`font-bold text-xl cursor-pointer ml-14 pb-2 focus:outline-none ${
       selectedTab === 3 ? 'text-textBlue1 border-b-4 border-blueBtn' : 'text-parameter opacity-60'
      }`}
     >
      Edit Device Information
     </button>
    </div> */}

        <div>
          {selectedTab === 1 ? (
            <InventoryManagement
              openDeviceInfo={() => {
                selectTab(2);
              }}
              notification={notification}
            />
          ) : (
            <DeviceInformation
              refreshList={refreshList}
              action={selectedTab === 3 ? 'update' : 'create'}
              selectedDevice={selectedDevice}
              notification={notification}
              handleClose={handleClose}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Inventory;
